export const short = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "—");

// shareable invite link for a private (invite-only) deal
export const dealLink = (id) => `${window.location.origin}${window.location.pathname}?deal=${id}`;

export const fmtAmt = (n) => {
  if (n == null) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return n.toLocaleString("en-US", { maximumFractionDigits: 2 });
};

// generic fixed-decimal number, no currency unit
export const fmtNum = (n, d = 2) => (n == null ? "—" : `${Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d })}`);

// USD amount, compact for large values
export const fmtUsd = (n, d = 0) => {
  if (n == null) return "—";
  const v = Number(n);
  const sign = v < 0 ? "−" : "";
  const abs = Math.abs(v);
  return `${sign}$${abs.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d })}`;
};

// token price quoted as USD per 1,000,000 tokens
export const fmtPrice = (p) => (p == null ? "—" : `$${(p * 1e6).toLocaleString("en-US", { maximumFractionDigits: 2 })}`);

export const fmtPct = (n, d = 2) => (n == null ? "—" : `${n >= 0 ? "" : "−"}${Math.abs(n).toFixed(d)}%`);

// canonical, on-chain-accurate explanation of why escrow saves cost
export const whyEscrow = (stock = "NVDA") =>
  `Each Pons token trades in its own Uniswap v4 pool paired against a tokenized stock. Every ${stock} pool references the same real ${stock} market price, so a block sold into one pool pushes its price off the real quote and arbitrage bots transmit that move across every ${stock}-paired pool within blocks. Cross settles the whole block off-market at one agreed price — no pool is touched, so no arbitrage fires.`;

export const ago = (isoStr) => {
  const s = Math.max(0, (Date.now() - new Date(isoStr).getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const countdown = (secs) => {
  if (secs == null) return "—";
  if (secs <= 0) return "00:00:00";
  const h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = Math.floor(secs % 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const clock = (isoStr) => new Date(isoStr).toISOString().slice(11, 19);

export const STATUS = {
  open: { label: "OPEN", cls: "border-white/20 text-slate-300" },
  seller_funded: { label: "SELLER FUNDED", cls: "border-violet/60 text-violet-300 bg-violet/10" },
  buyer_funded: { label: "BUYER FUNDED", cls: "border-violet/60 text-violet-300 bg-violet/10" },
  settled: { label: "SETTLED", cls: "border-pos/50 text-pos bg-pos/10" },
  refunded: { label: "REFUNDED", cls: "border-warn/50 text-warn bg-warn/10" },
  expired: { label: "EXPIRED", cls: "border-white/10 text-slate-500" },
  cancelled: { label: "WITHDRAWN", cls: "border-white/10 text-slate-500" },
};
